import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";
import { PasswordRules } from "@/pages/ChangePassword";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await register(form); navigate("/dashboard"); }
    catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === "string" ? d : Array.isArray(d) ? d.map(x => x.msg).join(" ") : "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[88vh] flex items-center" data-testid="register-page">
      <Seo title="Create Account" path="/register" noindex />
      <div className="container-x grid grid-cols-12 gap-8 items-center">
        <div className="col-span-12 lg:col-span-5">
          <div className="overline mb-4">// CREATE ACCOUNT</div>
          <h1 className="font-heading text-5xl tracking-tighter mb-3">Join the academy.</h1>
          <p className="text-neutral-400 mb-8">Enroll in courses. Track progress. Earn certifications.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="label-mono mb-2">Full Name</div>
              <input data-testid="register-name" className="field" value={form.name} onChange={update("name")} required />
            </div>
            <div>
              <div className="label-mono mb-2">Email</div>
              <input data-testid="register-email" className="field" type="email" value={form.email} onChange={update("email")} required autoComplete="email" />
            </div>
            <div>
              <div className="label-mono mb-2">Phone</div>
              <input data-testid="register-phone" className="field" value={form.phone} onChange={update("phone")} />
            </div>
            <div>
              <div className="label-mono mb-2">Password</div>
              <input data-testid="register-password" className="field" type="password" minLength={12} value={form.password} onChange={update("password")} required autoComplete="new-password" />
              <PasswordRules value={form.password} />
            </div>
            {error && <div data-testid="register-error" className="font-mono text-sm text-red-400">{error}</div>}
            <button disabled={loading} type="submit" data-testid="register-submit" className="btn-primary w-full justify-center">
              {loading ? "Creating account..." : "Create Account"} <ArrowRight size={14} />
            </button>
          </form>
          <div className="mt-6 font-mono text-xs text-neutral-500">
            Already have an account? <Link to="/login" className="text-[#FFD300]" data-testid="go-login">Sign in →</Link>
          </div>
        </div>
        <div className="hidden lg:block lg:col-span-6 lg:col-start-7">
          <div className="aspect-square overflow-hidden border border-white/10">
            <img src="/media/range-a-poster.jpg" alt="Range training at Secrecy Executive Training Academy" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
}
